<ng-container *ngIf="user.roles | userRole: 'MioAdministrator'">
  <div class="form">
    <div class="form-group">
      <label>Заголовок</label>
      <input type="text" class="form-control" [(ngModel)]="newNews.title" placeholder="Введите заголовок" />
    </div>
    <div class="form-group">
      <label>Текст</label>
      <textarea rows="5" [(ngModel)]="newNews.newsText"></textarea>
    </div>
    <div class="form-group">
      <div class="region" *ngFor="let r of regions">
        <div class="region-inner" (click)="toggleRegion(r)" [ngClass]="getRegionClass(r)">{{r.name}}</div>
      </div>
      <div class="clearfix"></div>
    </div>
    <div class="form-group">
      <label></label>
      <input #fileInput type="file" (change)="uploadDocument($event.target.files)" />
    </div>
    <div class="btns">
      <div class="btn btn-apply" (click)="addNews()">Отправить</div>
      <div class="btn btn-cancel" routerLink="/">Отменить</div>
    </div>
  </div>
  <ng-container *ngIf="errorMessage">
      <div class="error-message">
        <span>
          {{errorMessage}}
        </span>
        <span>
          {{'Обратитесь в службу поддержки!'}}
        </span>
      </div>
  </ng-container>
</ng-container>

<ng-container *ngIf="notificationIsShow">
  <app-modal-window [visible]="notificationIsShow" [width]="400" [scrollbar]="false">
    <div class="notification"> 
       Ваше сообщение успешно отправлено...
    </div>
  </app-modal-window>
</ng-container>

<ng-container *ngIf="loader">
  <div class="loading"></div>
</ng-container>

<ng-container *ngIf="!user.roles | userRole: 'MioAdministrator'">
  <div class="articles">
    <div class="article" *ngFor="let article of articles; let i = index;" [ngClass]="article.isChecked === 1 ? '' : 'bold'" (click)="openNew(i, article.id)">

      <div class="article__inner">
        <div class="article-index">{{i+1}}.</div>
        <div class="article-title">{{article.title}}</div>
        <div class="article-desc">{{article.newsText}}</div>
        <div class="article-date">{{getDate(article.updatedOn)}}</div>
        <a class="download-file" [href]="getDownload(article.dbFileID)">{{article.dbFileID === null ? '' : 'Скачать файл'}}</a>
      </div>

      <div class="opened-new" *ngIf="article.isOpen">
        <div class="title">{{selectedNew.title}}</div>
        <div class="text">{{selectedNew.newsText}}</div>
      </div>

    </div>



  </div>
</ng-container>